import { createFileRoute } from "@tanstack/react-router"
import PlayerTransfer from "@/app/settings/club/transition/page"

export const Route = createFileRoute("/settings/club/transition")({
  component: PlayerTransfer,
})
